import './frontend/index';
// import './frontend/map';
// import './modules/dropzone';
// import './modules/videojs';
// import './modules/flatpickr';
// import './modules/sweetalert2';
// import './modules/datatables';
// import './modules/chatgpt';
// import './modules/youtube';

// Styles
import '../sass/main.scss';

// Images.
// import '../img/cats.jpg';
import '../img/trusted-by-flutterwave.png';

// Icons
// import '../icons/quicklogin.svg';
